export default __webpack_public_path__ + "static/media/002-transferencia-mvil.6bcc6660.png";